/**
 * Review / ratings utilities.
 *
 * Moved from templates/components/scripts/review-utils.html (Phase 3 refactor).
 * Handlebars dependency (Shopper Approved site ID) is read at call-time from
 * window.BC_CONTEXT which is populated by init-globals.html before the bundle loads.
 */

export async function getReviewStars(skus) {
    console.debug("getReviewStars ", skus);
    if (Array.isArray(skus)) {
        return getReviewStarsArray(skus);
    } else {
        return getReviewStarsArray([skus]);
    }
}

export async function getReviewStarsArray(skus) {
    console.debug("saLoadScript observeTargetNode");
    const siteId = window.BC_CONTEXT?.shopperApprovedSiteId || '';

    if (!siteId) {
        console.error("siteId is required");
        return null;
    }
    if (!skus || skus.length === 0) {
        console.warn("No SKUs provided.");
        return [];
    }

    const baseUrl = `https://api.shopperapproved.com/aggregates/products/${siteId}/${skus.join(',')}?token=ea1664f192&xml=false`;

    try {
        const response = await fetch(baseUrl, {
            method: 'GET',
            headers: {
                'accept': '*/*'
            }
        });

        if (!response.ok) {
            console.error(`HTTP error! status: ${response.status}`);
            return null;
        }

        const data = await response.json();

        if (!data || !data.certificate_url || !data.product_totals) {
            console.warn("Unexpected data format from API:", data);
            return null;
        }

        const results = [];

        for (const sku of skus) {
            const htmlTag = `<a href="${data.certificate_url}" target="_blank" rel="noopener noreferrer">Shopper Approved Reviews</a>`;

            results.push({
                sku: sku,
                reviewData: data,
                html: htmlTag
            });
        }

        return results;

    } catch (error) {
        console.error("Fetch error:", error);
        return null;
    }
}

export function isValidLoginPassword(password) {
    // At least 7 characters
    if (password.length < 7) {
        return false;
    }

    // At least one letter
    const hasLetter = /[a-zA-Z]/.test(password);

    // At least one number
    const hasNumber = /\d/.test(password);

    return hasLetter && hasNumber;
}
